import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ScreenTime } from './components/ScreenTime';
import { Situations } from './components/Situations';
import { Pillars } from './components/Pillars';
import { Volumes } from './components/Volumes';
import { Stages } from './components/Stages';
import { ProjectExamples } from './components/ProjectExamples';
import { Bonuses } from './components/Bonuses';
import { Outcomes } from './components/Outcomes';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { About } from './components/About';
import { Faqs } from './components/Faqs';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { AnnouncementBar } from './components/AnnouncementBar';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23ujho4ly78zt">
      <AnnouncementBar data-id="element-1" data-mp="23ti5txx3yih1" />
      <main data-id="element-2" data-mp="3ikha0f5th31m">
        <Hero data-id="element-3" data-mp="3ikqwhsrnks2k" />
        <StatsBar data-id="element-4" data-mp="3ij65ue8glt9z" />
        <ScreenTime data-id="element-5" data-mp="3ijpdn24eb1aa" />
        <Situations data-id="element-6" data-mp="3mlja0y7k5j4n" />
        <Pillars data-id="element-7" data-mp="3ml13n8r6loj0" />
        <Volumes data-id="element-8" data-mp="3mkhm3t5g125i" />
        <Stages data-id="element-9" data-mp="3mjzrt22ccy08" />
        <ProjectExamples data-id="element-10" data-mp="3mjgannkimdn9" />
        <Bonuses data-id="element-11" data-mp="3rcj6618urx63" />
        <Outcomes data-id="element-12" data-mp="3rbzn2h7gv2qh" />
        <Offer data-id="element-13" data-mp="3rdkhm6ts6loc" />
        <Guarantee data-id="element-14" data-mp="3rcsuzli5vya7" />
        <About data-id="element-15" data-mp="3reltgdimfc74" />
        <Faqs data-id="element-16" data-mp="5ygolyg4xb6" />
        <FinalCta data-id="element-17" data-mp="6hq1ea16ddl" />
      </main>
      <Footer data-id="element-18" data-mp="4n7u7q58zd7" />
      <StickyCta data-id="element-19" data-mp="56l3b4umzkw" />
    </div>;
}